export default {
    namespaced: true,
    state() {
        return {
            showDisabled: true,
        };
    },
    getters: {
        showDisabled: state => state.showDisabled,
    },
    mutations: {
        setShowDisabled(state, showDisabled) {
            state.showDisabled = showDisabled;
        },
    },
    actions: {
        async changeShowDisabled({ commit }, value) {
            commit('setShowDisabled', value);
        },
    },
};
